import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../axios';
import { ENDPOINTS } from '../endpoints';

export const useCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const { data } = await axiosInstance.get(ENDPOINTS.CATEGORIES);
      return data.data;
    },
  });
};